import 'core-js/stable';
import 'regenerator-runtime/runtime';
// TODO 以下2行は将来的に確実に削除予定（i18n-reactからreact-i18nextに移行したら）
import T from 'i18n-react';
import merge from 'lodash/merge';
import moment from 'moment';

import '../scss/usersite-app.scss';
import '../src/usersite';

moment.locale('ja');

// 認証まわりなどで、aタグでdata-methodを使用するために必要なライブラリ
require('@rails/ujs').start();

T.setTexts(merge({}, require('../src/core/locales/ja.json')));
